interface Props {
  slice: any
}
const Quote = ({ slice }: Props) => {
  const { primary } = slice
  const author = primary?.author
  const authorTitle = primary?.authorTitle
  const quoteText = primary?.quoteText
  return (
    <div className="bg-ui-light-grey wrapper flex flex-col lg:gap-8 gap-4 py-8 lg:py-20">
      {quoteText && (
        <div className="lg:w-[864px] w-full heading-mobile-2 lg:heading-2 text-brand-dark-grey">
          {quoteText}
        </div>
      )}
      <div className="flex gap-4">
        {author && (
          <div className="label-bold text-brand-dark-grey">{author}</div>
        )}
        {authorTitle && (
          <div className="label text-brand-dark-grey">{authorTitle}</div>
        )}
      </div>
    </div>
  )
}

export default Quote
